import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../shared/table-pagination.css';

/**
 * A component displaying Pagination for a table with server-side pagination
 *
 */
class TablePagination extends Component {
    constructor(props) {
        super(props);
        let canNext = (((props.page + 1) * props.pageSize) < props.total);
        this.state = {
            canNext: canNext,
            canPrev: false,
        };

        this.setNavigationButtons = this.setNavigationButtons.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.page !== this.props.page ||
            nextProps.pageSize !== this.props.pageSize ||
            nextProps.total !== this.props.total
        ) {
            this.setNavigationButtons(nextProps.page, nextProps.pageSize, nextProps.total);
        }
    }

    setNavigationButtons = (page, pageSize, total) => {
        let canPrev = (page !== 0);
        let canNext = (((page + 1) * pageSize) < total);
        if (pageSize >= total && page === 0) {
            canNext = false;
        }
        this.setState({
            canNext: canNext,
            canPrev: canPrev
        });
    };

    handleChange = (e, type) => {
        let page = this.props.page;
        let pageSize = this.props.pageSize;
        let total = this.props.total;
        if (type === 'page') {
            // Unused
            page = parseInt(e.target.value, 10);
        }
        if (type === 'pageSize') {
            pageSize = parseInt(e.target.value, 10);
        }
        if (type === 'prev') {
            page -= 1;
        }
        if (type === 'next') {
            page += 1;
        }
        if (page < 0) {
            page = 0;
        }
        if (page >= total) {
            page = total;
        }
        if (pageSize !== this.props.pageSize) {
            page = 0;
        }
        const newValues = {
            page: page,
            pageSize: pageSize
        };
        if (typeof this.props.onChangeFunc === 'function') {
            this.props.onChangeFunc(newValues);
        }
    };

    renderPageOptions = (list) => {
        return (
            list.map((item, idx) => (
                <option
                    key={`pageOption-${item}-${idx}`}
                    value={item}
                >
                    {item} rows
                </option>
            ))
        )
    };

    render() {
        const {
            page,
            pageSize,
            pageSizeOptions,
            total
        } = this.props;

        const {
            canNext,
            canPrev
        } = this.state;

        const pageTotal = Math.ceil(total / pageSize);

        return (
            <div className="ReactTablePagination">
                <div className="pagination-bottom">
                    <div className="-pagination">
                        <div className="-previous">
                            <button type="button" disabled={!canPrev} className="-btn"
                                    onClick={(e) => this.handleChange(e, 'prev')}>Previous
                            </button>
                        </div>
                        <div className="-center">
                        <span className="-pageInfo">
                            Page&nbsp;
                            <div className="-pageJump">{page + 1}</div>
                            &nbsp;of&nbsp;
                            <span className="-totalPages">{pageTotal}</span>
                        </span>
                            <span className="select-wrap -pageSizeOptions">
                            <select
                                defaultValue={pageSize.toString()}
                                onChange={(e) => this.handleChange(e, 'pageSize')}>
                                {[...this.renderPageOptions(pageSizeOptions)]}
                            </select>
                        </span>
                        </div>
                        <div className="-next">
                            <button type="button" disabled={!canNext} className="-btn"
                                    onClick={(e) => this.handleChange(e, 'next')}>Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TablePagination.propTypes = {
    onChangeFunc: PropTypes.func,
    page: PropTypes.number,
    pageSize: PropTypes.number,
    pageSizeOptions: PropTypes.array,
    total: PropTypes.number
};
TablePagination.defaultProps = {
    page: 0,
    pageSize: 10,
    pageSizeOptions: [5, 10, 20, 50],
    total: 0,
};

export default TablePagination;



// WEBPACK FOOTER //
// ./src/Fuse/components/TablePagination.js